import React, { Component } from "react";
import App_data from "../config/App_data";
import FD from "../RestAPI/fetchData";
import language from "../../assets/languages/language";
import GD from "../RestAPI/getData";
import PaymentModalComponent from "../Common/paymentModel";

/* eslint-disable*/
class paymentProcessing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      exams: [],
      token: "",
      idname: "",
      ValidToken: false,
      chapter_id: "",
      offset: 0,
      limit: 10,
      answered: [],
      plan_data: "",
      pack_class: "hide_block",
      exam_name: "",
      exam_class: "row",
      extras_1: false,
      extras_2: false,
      checkedStatus: false,
      disable: false,
      params: window.location.href,
      url: new URL(window.location.href),
      source: "",
      livemode: "",
      client_secret: "",
      user_city: "",
      user_country: "",
      user_ip: "",
      Trans_id: "",
      order_id: "",
      classid: "",
      message: "",
      button: "",
      China_price: 6.55,
      canadian_price: 5.22,
      usd_canadian_price: 1.26,
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  /*
--------------------------------------  
  Function to get USD to yuan price
-------------------------------------
  */

  getChinaPrice = () => {
    GD.GetCallAPI("https://api.exchangeratesapi.io/latest?base=USD").then(
      (resp) => {
        this.setState({
          China_price: resp.rates.CNY,
          usd_canadian_price: resp.rates.CAD,
        });
      }
    );
    GD.GetCallAPI("https://api.exchangeratesapi.io/latest?base=CAD").then(
      (resp) => {
        this.setState({
          canadian_price: resp.rates.CNY,
        });
      }
    );
  };
  async componentDidMount() {
    GD.GetCallAPI("https://geolocation-db.com/json/").then((resp) => {
      // console.log("resp");
      this.setState({
        user_city: resp.city,
        user_country: resp.country_name,
        user_ip: resp.IPv4,
      });
    });
    // this.getChinaPrice();
    var storage_session = JSON.parse(localStorage.getItem("localstorageval"));
    this.setState({
      idname: storage_session["idname"],
      token: storage_session["token"],
    });

    this.setState(
      {
        source: this.state.url.searchParams.get("source"),
        livemode: this.state.url.searchParams.get("livemode"),
        client_secret: this.state.url.searchParams.get("client_secret"),
        Trans_id: this.state.url.searchParams.get("source"),
      },
      () => {
        this.state.source ? this.redirectToAlipayAgain() : null;
      }
    );
  }

  redirectToAlipayAgain = () => {
    this.setState({ startLoaderPage: true });

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      payment_type: "ali-pay",
      source: this.state.source,
      livemode: this.state.livemode,
      client_secret: this.state.client_secret,
      user_city: this.state.user_city,
      user_ip: this.state.user_ip,
      user_country: this.state.user_country,
    };

    FD.callAPI(
      App_data.backend_api + "/checkout_v1/AlipaySourceVerify",
      data
    ).then(async (resp) => {
      if (resp.success) {
        if (resp.status === "consumed") {
          this.setState({
            MessageContent: "Payment Successful",
            imageName: "success-ic.svg",
            order_id: resp.order_id.id,
            alert_status: true,
            classid: "success",
            button: "View order details",
            message: "Your transaction was successful.",
          });
        } else if (resp.status === "failed") {
          this.setState({
            imageName: "fail-ic.svg",
            MessageContent: "Payment Failed",
            alert_status: true,
            classid: "faild",
            button: "Go to Cart",
            message:
              "Your transaction has failed. Kindly try and make the payment again.",
          });
        } else {
          console.log("other-status", resp.status);
        }
      } else {
        this.setState({ startLoaderPage: false });
        console.log("Error!!");
        alert(resp.message);
      }
      return resp;
    });
  };

  render() {
    return (
      <div>
        {this.state.alert_status ? (
          <PaymentModalComponent
            token={this.state.token}
            idname={this.state.idname}
            toggleAlert={this.toggleAlert.bind(this)}
            alert_status={this.state.alert_status}
            MessageContent={this.state.MessageContent}
            imageName={this.state.imageName}
            Trans_id={this.state.Trans_id}
            China_price={this.state.China_price}
            canadian_price={this.state.canadian_price}
            order_id={this.state.order_id}
            classid={this.state.classid}
            message={this.state.message}
            button={this.state.button}
          />
        ) : null}
      </div>
    );
  }
}

export default paymentProcessing;



// WEBPACK FOOTER //
// ./src/views/Cart/paymentProcessing.js